const btnVarCss = name => {
    return 'btn-start-chat-' + name
}

import config from '@/config/index.js'
import store from '@/store/store'

const setVarCssButton = (buttonScheme, variables) => {
    if (buttonScheme) {
        let { font, color: bg, color_hover: bgHover, opacity, size } = buttonScheme

        if (font) {
            variables[btnVarCss('color')] = font.color
            variables[btnVarCss('font-size')] = font.size + 'px'
            variables[btnVarCss('font-family')] = font.family

            if (font.style == 'italic') {
                variables[btnVarCss('font-style')] = 'italic'
            } else if (font.style == 'bold-italic') {
                variables[btnVarCss('font-style')] = 'italic'
                variables[btnVarCss('font-weight')] = 'bold'
            } else {
                variables[btnVarCss('font-weight')] = font.style
            }
        }
        variables[btnVarCss('opacity')] = parseInt(opacity) / 100
        variables[btnVarCss('bg')] = bg
        variables[btnVarCss('bg-hover')] = bgHover
        variables[btnVarCss('size')] = size + 'px'
    }
    return variables
}

const setVarCssScheme = (defaultScheme, ownScheme, variables) => {
    if (defaultScheme) {
        if (defaultScheme > 1) {
            if (defaultScheme == 2 || defaultScheme == 3) {
                if (defaultScheme == 2) {
                    variables['image-pattern'] = 'none'
                }
                variables['color-bg-main'] = '#fff'
                variables['color-bg-main-2'] = '#fff'
                variables['color-text-main'] = '#3f4257'
                variables['color-header-control'] = '#3f4257'
                variables['color-message-bg'] = '#329eff'
            }
            if (defaultScheme == 4) {
                variables['image-pattern'] = 'none'

                variables['color-bg-main'] = '#2f3243'
                variables['color-bg-main-2'] = '#2f3243'
                variables['color-text-main'] = '#fff'
                variables['color-header-control'] = '#fff'
                ;(variables['color-message-bg-2'] = '#f76d6a'),
                    (variables['color-message-text-2'] = '#fff'),
                    (variables['color-message-bg'] = '#7567f8'),
                    (variables['color-message-text'] = '#fff')
            }

            if (defaultScheme == 5) {
                variables['image-pattern'] = 'none'

                variables['color-bg-main'] = '#eef8ff'
                variables['color-bg-main-2'] = '#eef8ff'
                variables['color-text-main'] = '#000'
                variables['color-header-control'] = '#000'
                ;(variables['color-message-bg-2'] = '#ff8001'),
                    (variables['color-message-text-2'] = '#fff'),
                    (variables['color-message-bg'] = '#00a51d'),
                    (variables['color-message-text'] = '#fff')
            }
            if (defaultScheme == 6) {
                variables['color-bg-main'] = '#59489b'
                variables['color-bg-main-2'] = '#e2267e'
                variables['color-text-main'] = '#fff'
                variables['color-header-control'] = '#fff'
                ;(variables['color-message-bg-2'] = '#6244ff'),
                    (variables['color-message-text-2'] = '#fff'),
                    (variables['color-message-bg'] = '#18719d'),
                    (variables['color-message-text'] = '#fff')
            }
            if (defaultScheme == 7) {
                variables['image-pattern'] = 'none'

                variables['color-bg-main'] = '#343e9f'
                variables['color-bg-main-2'] = '#1bfefe'
                variables['color-text-main'] = '#fff'
                variables['color-header-control'] = '#fff'
                ;(variables['color-message-bg-2'] = '#2d395d'),
                    (variables['color-message-text-2'] = '#fff'),
                    (variables['color-message-bg'] = '#ee69a4'),
                    (variables['color-message-text-2'] = '#fff')
            }
        }
    } else if (ownScheme) {
        let {
            manager_message,
            guest_message,
            header_button: { color: colorHeaderControl },
            font: { color: colorTextMain, size, family, style: weight },
            border: { radius },
            background: {
                style,
                color,
                color1,
                color2,
                image: {
                    custom: { url, enable: imageEnable }
                }
            }
        } = ownScheme

        ;(variables['radius'] = radius),
            (variables['color-text-main'] = colorTextMain),
            (variables['color-header-control'] = colorHeaderControl),
            (variables['font-size-main'] = size + 'px'),
            (variables['font-family-name'] = family),
            (variables['font-weight'] = weight),
            (variables['color-message-bg'] = manager_message.background.color),
            (variables['color-message-text'] = manager_message.color),
            (variables['color-message-bg-2'] = guest_message.background.color),
            (variables['color-message-text-2'] = guest_message.color)

        if (weight == 'italic') {
            variables['font-style'] = 'italic'
        } else if (weight == 'bold-italic') {
            variables['font-style'] = 'italic'
            variables['font-weight'] = 'bold'
        } else {
            variables['font-weight'] = weight
        }
        if (style == 'gradient') {
            variables['color-bg-main'] = color1
            variables['color-bg-main-2'] = color2
        } else {
            variables['color-bg-main'] = color
            variables['color-bg-main-2'] = color
        }

        if (!imageEnable) {
            variables['image-pattern'] = 'none'
        } else if (url) {
            variables['image-pattern'] = `url(${url})`
        }
        variables['raduis'] = `${radius}px`
    }
    return variables
}

const setVarCssButtonPosition = (buttonPosition, localStorage) => {
    function calcPosition(val, pos) {
        if (localStorage[pos] == null) return parseInt(val) + '%'
        else return parseInt(localStorage[pos]) + '%'
    }

    let { type, user, sticky } = buttonPosition
    let left, top

    if (sticky) {
        if (sticky.place == '1') {
            left = calcPosition(sticky.offset, 'left')
            top = calcPosition(0, 'top')
        }

        if (sticky.place == '2') {
            left = calcPosition(sticky.offset, 'left')
            top = calcPosition(100, 'top')
        }
        if (sticky.place == '3') {
            top = calcPosition(sticky.offset, 'top')
            left = calcPosition(0, 'left')
        }
        if (sticky.place == '4') {
            top = calcPosition(sticky.offset, 'top')
            left = calcPosition(100, 'left')
        }
    } else if (type == '0') {
        left = calcPosition(user.horizontal, 'left')
        top = calcPosition(user.vertical, 'top')
    } else {
        if (type == '1') {
            left = calcPosition(0, 'left')
            top = calcPosition(0, 'top')
        }
        if (type == '2') {
            left = calcPosition(50, 'left')
            top = calcPosition(0, 'top')
        }
        if (type == '3') {
            left = calcPosition(100, 'left')
            top = calcPosition(0, 'top')
        }
        if (type == '4') {
            left = calcPosition(0, 'left')
            top = calcPosition(50, 'top')
        }

        if (type == '5') {
            left = calcPosition(50, 'left')
            top = calcPosition(50, 'top')
        }
        if (type == '6') {
            left = calcPosition(100, 'left')
            top = calcPosition(50, 'top')
        }

        if (type == '7') {
            left = calcPosition(0, 'left')
            top = calcPosition(100, 'top')
        }
        if (type == '8') {
            left = calcPosition(50, 'left')
            top = calcPosition(100, 'top')
        }
        if (type == '9') {
            left = calcPosition(100, 'left')
            top = calcPosition(100, 'top')
        }
    }

    return { left, top }
}

const getDefaultState = () => {
    return {
        show: false,
        frame: false,
        button: false,
        buttonSize: {
            height: 0,
            width: 0
        },
        localStorage: {
            showBtnStart: config.siteOptions.common.show_widget_button,
            showWidget: true,
            left: null,
            top: null
        }
    }
}

// initial state
const state = getDefaultState()

export default {
    namespaced: true,
    state,
    mutations: {
        resetState(state) {
            Object.assign(state, getDefaultState())
        },
        setApi(state, api) {
            state.frame = api.design.frame
            state.button = api.design.button
        },

        setButtonSize(state, val) {
            let { width, height } = val

            state.buttonSize.height = height
            state.buttonSize.width = width
        },

        setShow(state) {
            state.show = true
        },

        setLocalStorage(state, { showWidget, showBtnStart, left, top, zIndex }) {
            if (showBtnStart !== undefined) state.localStorage.showBtnStart = showBtnStart
            if (showWidget !== undefined) state.localStorage.showWidget = showWidget
            if (left !== undefined) state.localStorage.left = left
            if (top !== undefined) state.localStorage.top = top
            if (zIndex !== undefined) state.localStorage.zIndex = zIndex
        }
    },
    actions: {},
    getters: {
        showBtnStart: (state, getters) => {
            return config.siteOptions.common.show_widget_button
        },
        defaultScheme: (state, getters) => {
            if (state.frame.type == '0')
                return parseInt(state.frame['type_' + state.frame.type].scheme)
            else return false
        },
        ownScheme: (state, getters) => {
            if (state.frame.type == '1') return state.frame['type_' + state.frame.type]
            else return false
        },
        position: (state, getters) => {
            if (state.frame.type == '1') return state.frame['type_' + state.frame.type]
            else return false
        },
        imageOffline: (state, getters) => {
            return state.frame?.image_offline?.custom.url
        },

        buttonType: state => {
            return state.button.type
        },
        buttonScheme: (state, getters) => {
            return state.button['type_' + getters.buttonType]
        },
        buttonAnimationOff: (state, getters) => {
            return getters.buttonScheme?.animation?.disable
        },
        buttonText: (state, getters, rootState, rootGetters) => {
            if (rootGetters.operator.online) return getters.buttonScheme?.text?.online
            else return getters.buttonScheme?.text?.offline
        },
        buttonNoText: (state, getters) => {
            return getters.buttonType == '0' || getters.buttonType == '1'
        },

        buttonPosition: (state, getters) => {
            return {
                type: getters.buttonScheme?.position,
                user: getters.buttonScheme?.position_0,
                sticky: getters.buttonScheme?.position_sticky
            }
        },
        buttonPositionSticky: (state, getters) => {
            return getters.buttonPosition.sticky?.place
        },

        cssAllVar: (state, getters, rootState, rootGetters) => {
            let variables = {}

            variables['show'] = 'block'

            /*if (state.allowButtonSize && state.buttonSize.width && state.buttonSize.height) {
                variables['btn-start-width'] = state.buttonSize.width + 'px'
                variables['btn-start-height'] = state.buttonSize.height + 'px'
            }*/

            if (!rootGetters.operator.online) {
                variables['image-avatar'] = 'url(' + getters.imageOffline + ')'
            } else {
                variables['image-avatar'] = 'url(' + rootState.api.employee.photo + ')'
            }

            variables = setVarCssScheme(getters.defaultScheme, getters.ownScheme, variables)

            variables = setVarCssButton(getters.buttonScheme, variables)

            return variables
        },
        /* menuPositionVertical: (state, getters) => {
            if(parseInt(getters.cssAllVar.top) > 75) return 'top'
            else if(parseInt(getters.cssAllVar.top) <= 75 && parseInt(getters.cssAllVar.top) >= 25) return 'middle'

            else  return 'bottom'

        },
        menuPositionHorizontal: (state, getters) => {
            if(parseInt(getters.cssAllVar.left) > 75) return 'left'
            else if(parseInt(getters.cssAllVar.left) <= 75 && parseInt(getters.cssAllVar.left) >= 25) return 'center'
            else  return 'right'

        },*/
        cssButtonPosition: (state, getters) => {
            function calcPosition(val, pos) {
                // return config.siteOptions.design.buttonLeft || (parseInt(val) + '%')
                return parseInt(val) + '%'
                // if (state.localStorage[pos] == null) return parseInt(val) + '%'
                // else return parseInt(state.localStorage[pos]) + '%'
            }

            let { type, user, sticky } = getters.buttonPosition
            let left, top

            if (sticky) {
                if (sticky.place == '1') {
                    left = calcPosition(sticky.offset, 'left')
                    top = calcPosition(0, 'top')
                }

                if (sticky.place == '2') {
                    left = calcPosition(sticky.offset, 'left')
                    top = calcPosition(100, 'top')
                }
                if (sticky.place == '3') {
                    top = calcPosition(sticky.offset, 'top')
                    left = calcPosition(0, 'left')
                }
                if (sticky.place == '4') {
                    top = calcPosition(sticky.offset, 'top')
                    left = calcPosition(100, 'left')
                }
            } else if (type == '0') {
                left = calcPosition(user.horizontal, 'left')
                top = calcPosition(user.vertical, 'top')
            } else {
                if (type == '1') {
                    left = calcPosition(0, 'left')
                    top = calcPosition(0, 'top')
                }
                if (type == '2') {
                    left = calcPosition(50, 'left')
                    top = calcPosition(0, 'top')
                }
                if (type == '3') {
                    left = calcPosition(100, 'left')
                    top = calcPosition(0, 'top')
                }
                if (type == '4') {
                    left = calcPosition(0, 'left')
                    top = calcPosition(50, 'top')
                }

                if (type == '5') {
                    left = calcPosition(50, 'left')
                    top = calcPosition(50, 'top')
                }
                if (type == '6') {
                    left = calcPosition(100, 'left')
                    top = calcPosition(50, 'top')
                }

                if (type == '7') {
                    left = calcPosition(0, 'left')
                    top = calcPosition(100, 'top')
                }
                if (type == '8') {
                    left = calcPosition(50, 'left')
                    top = calcPosition(100, 'top')
                }
                if (type == '9') {
                    left = calcPosition(100, 'left')
                    top = calcPosition(100, 'top')
                }
            }

            return { left, top }
        },
        menuPositionVertical: (state, getters) => {
            let top = parseInt(getters.cssButtonPosition.top)

            if (top > 50) return 'top'
            else return 'bottom'
        },
        menuPositionHorizontal: (state, getters) => {
            let left = parseInt(getters.cssButtonPosition.left)

            if (left > 50) return 'left'
            else return 'right'
        },
        chatPositionVerticalOffset: (state, getters) => {
            let top = parseInt(getters.cssButtonPosition.top)

            if (top > 50) return 'top'
            else return 'bottom'
        },
        chatPositionHorizontalOffset: (state, getters) => {
            let left = parseInt(getters.cssButtonPosition.left)
            let top = parseInt(getters.cssButtonPosition.top)

            if (left > 50) {
                left = 100 - left
            } else {
                left *= -1
            }

            if (top > 50) {
                top = 100 - top
            } else {
                top *= -1
            }

            return {
                transform: 'translate(' + left + '%,' + top + '%)!important'
            }
        },
        menuOffsetLeftTop: (state, getters) => {
            //if(getters.buttonPositionSticky) return
            return {
                right: '250px !important',
                top: getters.cssButtonPosition.top + '!important'
            }
        },
        menuOffsetMarginLeftTop: (state, getters) => {
            //if(getters.buttonPositionSticky) return
            return {
                marginLeft: state.buttonSize.width / -2 + 'px!important',
                marginTop: state.buttonSize.height / -2 + 'px!important'
            }
        },

        widgetOffset: (state, getters) => {
            let ls = localStorage.getItem('effect-widget-store')
            ls = ls ? JSON.parse(ls) : {}
            if (ls.active_chat_id) {
                store.commit('setLocalStorage', ['showBtnStart', true])
            }
            return {
                display:
                    state.localStorage.showWidget || ls.active_chat_id
                        ? 'block!important'
                        : 'none!important',
                margin:
                    state.buttonSize.height / 2 +
                    'px ' +
                    state.buttonSize.width / 2 +
                    'px!important'
            }
        }
    }
}
